import React, { useState } from 'react'

import arrowIcon from '../../../assets/DashboardIcons/DashboardQAIcons/arrowIcon.png'

export default function DashboardQA() {
  const [openSections, setOpenSections] = useState({})

  const toggleSection = (key) => {
    setOpenSections(prev => ({
      ...prev,
      [key]: !prev[key]
    }))
  }

  return (
    <div className='shadow-full rounded-xl p-4 lg:w-full w-11/12 h-fit mt-10 flex flex-col bg-white mb-10'>
      <div className={`flex flex-row items-center ${openSections.q1 ? 'mb-4' : 'mb-10'} gap-4`}>
        <p className='font-bold lg:text-xl'>
          Is being self-employed a requirement to claim the tax credit refund?
        </p>
        <img onClick={() => toggleSection('q1')} className='h-6 cursor-pointer' style={{ transform: openSections.q1 ? 'rotate(90deg)' : 'rotate(-90deg)' }} src={arrowIcon} alt='arrowIcon' />
      </div>
      {openSections.q1 && (
        <p className='mb-10 pr-10'>
          Yes, eligibility for this tax credit is specifically tailored to self-employed individuals,
          including small business owners, freelancers, and 1099 contractors.
        </p>
      )}
      <div className={`flex flex-row items-center ${openSections.q2 ? 'mb-4' : 'mb-10'} gap-4`}>
        <p className='font-bold lg:text-xl'>
          What is the Sick & Family Leave Tax Credit?
        </p>
        <img onClick={() => toggleSection('q2')} className='h-6 cursor-pointer' style={{ transform: openSections.q2 ? 'rotate(90deg)' : 'rotate(-90deg)' }} src={arrowIcon} alt='arrowIcon' />
      </div>
      {openSections.q2 && (
        <div>
          <p className='mb-4 pr-10'>
            The Sick and Family Leave Tax Credit is a financial support measure designed for self-employed individuals and 1099 workers,
            created under the Families First Coronavirus Response Act (FFCRA). This legislation enables eligible individuals
            (gig workers, 1099, small business owners, certain partnerships, etc.) to claim a refundable tax credit. Since its creation,
            this historic tax credit was specifically aimed at providing relief for those unable to work or telework due to certain circumstances related to
            COVID-19.
          </p>
          <p className='mb-4 pr-10'>Key aspects of this tax credit include:</p>
          <p className='font-bold mv-4 pr-10'>(1) Qualified Sick Leave Credit:</p>
          <p className='mb-4 pr-10'>
            It covers up to 100% of qualified sick leave equivalent amounts, subject to a maximum of $511 per day.
          </p>
          <p className='mb-4 pr-10'>
            The calculation is based on the lesser of $511 per day or 100% of the individual's average daily self-employment income.
          </p>
          <p className='mb-4 pr-10'>
            This applies to days when an individual was unable to work due medically recommended or government ordered quarantine and/or
            isolation due to COVID-19, personally experiencing symptoms and seeking a diagnosis, or caring for someone under quarantine or
            with symptoms of COVID-19.
          </p>
          <p className='font-bold mv-4 pr-10'>(2) Qualified Family Leave Credit:</p>
          <p className='mb-4 pr-10'>
            The credit also extends to qualified family leave, covering up to 67% of the average daily self-employment income, with a maximum
            benefit of $200 per day.
          </p>
          <p className='mb-4 pr-10'>
            This is applicable for days when an individual could not work because they were required to care for a child whose school or care
            facility was closed due to COVID-19.
          </p>
          <p className='mb-10 pr-10'>
            These credits were established as part of broader effort by Congress to provide financial support to those impacted by the pandemic,
            acknowledging the unique challenges faced by self-employed individuals and independent contractors.
          </p>
        </div>
      )}
      <div className={`flex flex-row items-center ${openSections.q3 ? 'mb-4' : 'mb-10'} gap-4`}>
        <p className='font-bold lg:text-xl'>
          If I've already submitted my tax returns for 2020 and 2021, what should I do?
        </p>
        <img onClick={() => toggleSection('q3')} className='h-6 cursor-pointer' style={{ transform: openSections.q3 ? 'rotate(90deg)' : 'rotate(-90deg)' }} src={arrowIcon} alt='arrowIcon' />
      </div>
      {openSections.q3 && (
        <div>
          <p className='mb-10 pr-10'>
            Perfect, you’re all set. Now, simply visit our qualification form above, honestly answer the questions, and our
            technology will retrieve your past year’s tax data from the IRS. Once that information is received, we will provide
            you with your realized, maximum tax benefit under this program. Our process only takes a few minutes to complete.
            Best of all, checking your eligibility is 100% free.
          </p>
        </div>
      )}
      <div className={`flex flex-row items-center ${openSections.q4 ? 'mb-4' : 'mb-10'} gap-4`}>
        <p className='font-bold lg:text-xl'>
          Is there an extensive amount of paperwork to complete?
        </p>
        <img onClick={() => toggleSection('q4')} className='h-6 cursor-pointer' style={{ transform: openSections.q4 ? 'rotate(90deg)' : 'rotate(-90deg)' }} src={arrowIcon} alt='arrowIcon' />
      </div>
      {openSections.q4 && (
        <div>
          <p className='mb-10 pr-10'>
            Our proprietary process eliminates the need to upload any tax documents. Significant corporate partnerships allow SETC Pros
            to securely retrieve your 2020 and 2021 tax data from the IRS at no expense to you. </p>
        </div>
      )}
      <div className={`flex flex-row items-center ${openSections.q5 ? 'mb-4' : 'mb-10'} gap-4`}>
        <p className='font-bold lg:text-xl'>
          How long does the entire process take, from submission to potential benefits?
        </p>
        <img onClick={() => toggleSection('q5')} className='h-6 cursor-pointer' style={{ transform: openSections.q5 ? 'rotate(90deg)' : 'rotate(-90deg)' }} src={arrowIcon} alt='arrowIcon' />
      </div>
      {openSections.q5 && (
        <div>
          <p className='mb-4 pr-10'>
            Clients can complete our free application process in minutes, with no need to track down and upload years old tax documents.
            Once you’ve submitted your application, we typically receive your IRS data within about three to five business days.
            Once processed, we will send you an official calculation of your total maximum earned benefit amount.
          </p>
          <p className='mb-4 pr-10'>
            After one last easy step, you will receive the necessary filing documents from SETC Pros, which require a “wet” or actual signature,
            along with mailing instructions. SETC Pros provide all clients with free shipping to the nearest IRS location. Once received by the IRS,
            processing typically takes between four (4) and sixteen (16) weeks.
          </p>
          <p className='mb-10 pr-10'>
            Please note, per recent IRS information, 2020 refunds will be issued by paper check. 2021 refunds will be issued by direct deposit.
          </p>
        </div>
      )}
      <div className={`flex flex-row items-center ${openSections.q6 ? 'mb-4' : 'mb-10'} gap-4`}>
        <p className='font-bold lg:text-xl'>
          What if I have questions or need assistance during the process?
        </p>
        <img onClick={() => toggleSection('q6')} className='h-6 cursor-pointer' style={{ transform: openSections.q6 ? 'rotate(90deg)' : 'rotate(-90deg)' }} src={arrowIcon} alt='arrowIcon' />
      </div>
      {openSections.q6 && (
        <div>
          <p className='mb-10 pr-10'>
            If you have any questions or need assistance at any point during the process, please know that we are here to support you.
            Our dedicated team is always ready and available to help with any inquiries or concerns you might have. You can easily reach out
            to us through our designated contact channels, and we'll ensure that you receive the necessary guidance and clarification.
            We're committed to making this process as smooth and understandable as possible for you.
          </p>
        </div>
      )}
      <div className={`flex flex-row items-center ${openSections.q7 ? 'mb-4' : 'mb-10'} gap-4`}>
        <p className='font-bold lg:text-xl'>
          Are there any upfront fees for using the SETC Pros service?
        </p>
        <img onClick={() => toggleSection('q7')} className='h-6 cursor-pointer' style={{ transform: openSections.q7 ? 'rotate(90deg)' : 'rotate(-90deg)' }} src={arrowIcon} alt='arrowIcon' />
      </div>
      {openSections.q7 && (
        <div>
          <p className='mb-4 pr-10'>
            No, there are no upfront fees when you choose SETC Pros. Checking your eligibility and official maximum refund amount is 100% free. We are dedicated to
            making our services as accessible and hassle-free as possible.
          </p>
          <p className='mb-4 pr-10'>
            Our fee structure is designed so that charges are only applied after we have successfully secured your Self-Employed Tax Credits. For those who owe nothing
            in back taxes, we simply deduct our fee from your tax year 2021 refund after your funds are direct deposited into your bank account by the IRS. To ensure
            security and client privacy, SETC Pros has proudly partnered with Stripe® to obtain and transmit all payment information.
          </p>
          <p className='mb-10 pr-10'>
            If you do owe back taxes, don’t worry, SETC Pros will provide you with various payment options to help you clean up some, or hopefully all,
            of those burdensome back taxes. In many cases, we can completely eliminate any back taxes owed and still put funds into our client’s pockets—we absolutely
            love being a part of our client’s financial success stories.
          </p>
        </div>
      )}
      <div className={`flex flex-row items-center ${openSections.q8 ? 'mb-4' : 'mb-10'} gap-4`}>
        <p className='font-bold lg:text-xl'>
          How is the amount of my tax credit determined?
        </p>
        <img onClick={() => toggleSection('q8')} className='h-6 cursor-pointer' style={{ transform: openSections.q8 ? 'rotate(90deg)' : 'rotate(-90deg)' }} src={arrowIcon} alt='arrowIcon' />
      </div>
      {openSections.q8 && (
        <div>
          <p className='mb-4 pr-10'>
            The amount of your Self-Employed Tax Credit is determined based on a combination of key factors, including:
          </p>
          <p className='mb-4 pr-10'>
            <span className='font-bold'>(1) Net Income:</span> Your net business income, as reported on Schedule C of your 2019, 2020, and/or 2021 tax returns,
            is a critical factor. This provides a baseline for calculating your maximum potential credit. Per IRS guidelines, you may use the greater of your
            net business income for the tax year in which the credit is claimed or that of the previous year. Thus, for tax year 2020, you may use the greater
            of 2019 and 2020 to establish your maximum daily benefit. For your 2021 maximum benefit total, you may use the greater of tax year 2020 or 2021.
            Our proprietary AI driven software quickly identifies which combination is most advantageous for you in every instance.
          </p>
          <p className='mb-4 pr-10'>
            <span className='font-bold'>(3) Caregiving Duration:</span> If you spent time caring for an individual affected by COVID-19, the duration of this
            caregiving is considered.
          </p>
          <p className='mb-4 pr-10'>
            <span className='font-bold'>(4) School or Daycare Closures:</span> The length of time you needed to care for a minor child because their school or
            daycare center was closed due to COVID-19 is also a factor.
          </p>
          <p className='mb-10 pr-10'>
            Checking your official maximum refund amount with SETC Pros is always 100% free of charge. Our process only takes minutes to complete, and submissions are confidential.
          </p>
        </div>
      )}
      <div className={`flex flex-row items-center ${openSections.q9 ? 'mb-4' : 'mb-10'} gap-4`}>
        <p className='font-bold lg:text-xl'>
          If both the taxpayer and spouse have self-employed income, are they both eligible for the Self-Employed Tax Credit (SETC)?
        </p>
        <img onClick={() => toggleSection('q9')} className='h-6 cursor-pointer' style={{ transform: openSections.q9 ? 'rotate(90deg)' : 'rotate(-90deg)' }} src={arrowIcon} alt='arrowIcon' />
      </div>
      {openSections.q9 && (
        <div>
          <p className='mb-10 pr-10'>
            Yes, if both the taxpayer and their spouse have self-employed income, they are both eligible to claim the Self-Employment Tax Credit individually.
            It's crucial to understand, though, that they cannot overlap or share qualifying COVID-related days for which they claim the credit.
            Each individual's claim must be based on their own specific circumstances and periods of inability to work due to COVID-19.
          </p>
        </div>
      )}
      <div className={`flex flex-row items-center ${openSections.q10 ? 'mb-4' : 'mb-10'} gap-4`}>
        <p className='font-bold lg:text-xl'>
          Can I receive my funds faster than the standard IRS timeline?
        </p>
        <img onClick={() => toggleSection('q10')} className='h-6 cursor-pointer' style={{ transform: openSections.q10 ? 'rotate(90deg)' : 'rotate(-90deg)' }} src={arrowIcon} alt='arrowIcon' />
      </div>
      {openSections.q10 && (
        <div>
          <p className='pr-10'>
            For those clients who are interested, SETC Pros has partnered with several national lending partners, via TurboFi, offering loan options
            to unlock the freedom of your newfound funds within days. Many of our clients choose this option, rather than waiting up to sixteen (16)
            weeks for the IRS to process their file. Once the funds are received, you can either: (1) choose to pay any loan off in full or (2) simply
            continue making the monthly payment and use your refund for other purposes.
          </p>
        </div>
      )}
    </div>
  )
}